import React from 'react';
import { Field } from 'redux-form';

import { renderTextAreaField } from '../../../../../../utils/redux-form-helper';

import { FlexFormInputFull } from '../../common';

const RelocationOptionsFormFields = ({ values }: Object) => {
  return (
    <React.Fragment>
      <FlexFormInputFull>
        <Field
          name="Notes"
          component={renderTextAreaField}
          label="Notes"
          rows="3"
          maxLength="1000"
          showLabel
        />
      </FlexFormInputFull>
    </React.Fragment>
  );
};

export default RelocationOptionsFormFields;
